import React from 'react';
import clsx from 'clsx';
import styles from './Playlist.module.scss';
import ContentSection from '../ContentSection';
import Skeleton from '../Skeleton';

function PlaylistSkeleton({
  title,
  count = 4,
  grid = false,
  headerRight,
  noHeader,
}: {
  title?: string,
  count?: number,
  grid?: boolean,
  headerRight?: React.ReactNode,
  noHeader?: boolean,
}) {
  return (
    <ContentSection
      skeleton
      title={title}
      headerRight={headerRight}
      noHeader={noHeader}
    >
      <div className={clsx(
        styles.playlistPosts,
        styles.playlistPosts_skeleton,
        grid && styles.playlistPostsGrid,
        count === 3 && styles.playlistPosts_3,
      )}
      >
        {Array.from(Array(count).keys()).map((item) => (
          <div
            className={clsx(
              styles.playlistItem,
              grid && styles.playlistItemGrid,
              (grid && item === 0) && styles.playlistItemGridLarge,
            )}
            key={item}
          >
            <Skeleton className={styles.itemSkeleton} />
          </div>
        ))}
      </div>
    </ContentSection>
  )
}

export default PlaylistSkeleton
